module.exports = __webpack_public_path__ + "static/media/document.png.c645ee8b.png";